/* Copyright (c) 2021 Paul Nebel */

import React from 'react';
import PropTypes from 'prop-types';
import * as Tone from 'tone';
import { isEqual } from 'lodash';
import styled from 'styled-components';
import moment from 'moment';

import LogoLarge from './logo-large';
import InstallPwaNotification from './install-pwa-notification';

// sw-updater-notification uses service-worker-updater which has a version incompatibility with this code
// import UpdateNotification from './sw-update-notification';

// import { BUILD_ENV } from 'gatsby-env-variables';

const LogoLargeIcon = styled(LogoLarge)``;
const withSplashPage = (WrappedComponent) => {
    class SplashPage extends React.Component {
        constructor(props, context) {
            super(props, context);
            const { location } = props;
            const isReady = location.state ? location.state.ready : false;
            this.state = {
                ready: isReady,
            };
            this.startTone = this.startTone.bind(this);
        }

        async startTone() {
            await Tone.start();
            this.setState({ ready: true });
            // start with an empty buffer with an instance of AudioContext...
            const context = Tone.getContext();
            const buffer = context.createBuffer(1, 1, 22050);
            const node = context.createBufferSource();
            node.buffer = buffer;
            node.start(0);
        }

        showInstallPrompt() {
            try {
                const today = moment().toDate();
                const installPromptValue =
                    localStorage.getItem('installPrompt');
                let days = 0;
                let seconds = 30;
                if (installPromptValue !== undefined) {
                    const lastPrompt = moment(
                        new Date(installPromptValue).toISOString()
                    );
                    days = moment(today).diff(lastPrompt, 'days');
                    seconds = moment().diff(lastPrompt, 'seconds');
                }
                // if it's less than 3 seconds since we set the date we're probably still rendering
                const prompt = isNaN(days) || seconds < 3 || days > 30;
                // due to state updates, this method will be called multiple times. We don't want to set it unless it's not already set or the delay period has timed out
                if (isNaN(days) || days > 30) {
                    localStorage.setItem('installPrompt', today);
                }
                return prompt;
            } catch (ex) {
                return true;
            }
        }

        startButton() {
            return (
                <div
                    className="columns is-mobile is-flex"
                    style={{ height: '90vh' }}
                >
                    <div
                        className="column has-text-centered"
                        style={{ marginTop: '30%' }}
                    >
                        <div className="mb-6">
                            <LogoLargeIcon color="#dee5ed" className="mb-6" />
                        </div>
                        <button
                            className="button is-primary is-rounded mt-6 is-size-5"
                            onClick={this.startTone}
                        >
                            Ready? Let&rsquo;s Play
                        </button>
                    </div>
                    <InstallPwaNotification
                        isNotification={true}
                        name="splash"
                        options={{ customCriteria: this.showInstallPrompt }}
                    />
                    {/* { BUILD_ENV === 'production' && <UpdateNotification /> } */}
                </div>
            );
        }

        shouldComponentUpdate(nextProps, nextState) {
            return (
                !isEqual(nextProps, this.props) ||
                !isEqual(nextState, this.state)
            );
        }

        render() {
            // while checking user session, show 'loading' message
            if (this.state.ready) {
                return <WrappedComponent {...this.props} />;
            } else {
                // otherwise, show the desired route
                return this.startButton();
            }
        }
    }

    SplashPage.propTypes = {
        location: PropTypes.object,
    };

    return SplashPage;
};

export default withSplashPage;
